import AccountSettings from './Settings';
import CommunicationsView from './Communications';

export { AccountSettings };
export { CommunicationsView };